export default {
  environment: "production",
  appVersion: "2.4.0",
  timezone: "America/New_York",
  serverURL: 'https://pearl.cubepon.ca:8443/',
  blobPreURL: "https://cubeponblobaccount.blob.core.windows.net/coupon/",
  blobPostURL: "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2035-01-02T11:51:37Z&st=2025-01-02T03:51:37Z&spr=https&sig=GzYhMAiw6z3KXuaqItQzcUMVMSns%2B8GbZnaT6DOLzQw%3D",
  //
  sendSMS: true,
  sendEmail: true,
  twofaEnabled: true,
  showPaymentMethod: false,
  //
  offical: {
    email: {
      info: "info@cubepon.ca",
      admin: "info@cubepon.ca",
    },
    website: {
      contact: "https://www.pearlharbourfront.ca/contact/",
      TandC: "https://cubepon.ca/pearl-terms-conditions/",
      privacy: "https://cubepon.ca/pearl-privacy-policy/",
    },
    phone: "+1 (289) 800-1300",
    androidStore: "https://play.google.com/store/apps/details?id=restaurant.pearl.ca",
    appleStore: "https://apps.apple.com/us/app/pearl-chinese-cuisine/id6739810380",
    GA: {
      androidStore: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=zh_HK",
      appleStore: "https://apps.apple.com/hk/app/google-authenticator/id388497605?l=en",
    },
  },
  appLogoPath: "pearl-logo.png",
  //temporary
  region: "ca",
};
